'use strict';

angular.module('utils').factory('OCPeriodMapUtil', function($q, PrimeInvoiceService, UserService, OpencareConstants) {
  return {
    updateScopeWithPeriodMap: function($scope, entity, modelIds, modelType) {
      let getPeriodMaps;

      if (entity === 'billingEntity') {
        getPeriodMaps = $q.all(modelIds.map((modelId) => {
          return PrimeInvoiceService.getBillableEntityPeriodMap(modelType, modelId);
        }));
      } else if (entity === 'invoiceReport') {
        getPeriodMaps = $q.all(modelIds.map((modelId) => {
          return UserService.getClinicInvoiceReportPeriodMap(modelId);
        }));
      } else {
        return $q.reject();
      }

      return getPeriodMaps.then(function(periodMaps) {
        let billableYears = [];
        const billableMonthsByYear = {};

        for (const periodMap of periodMaps) {
          billableYears = billableYears.concat(periodMap.billableYears || periodMap.years || []);
          billableYears = _.chain(billableYears)
            .uniq()
            .sortBy()
            .value()
            .reverse();

          const _billableMonthsByYear = periodMap.billableMonthsByYear || periodMap.monthsByYear || {};

          for (const year of Object.keys(_billableMonthsByYear)) {
            billableMonthsByYear[year] = (billableMonthsByYear[year] || []).concat(_billableMonthsByYear[year]);
            billableMonthsByYear[year] = _.chain(billableMonthsByYear[year])
              .uniq()
              .sortBy()
              .value()
              .reverse();
          }
        }

        $scope.billableYears = billableYears;
        $scope.billableMonthsByYear = billableMonthsByYear;
        $scope.userSelected = $scope.userSelected || {};
        $scope.userSelected.period = $scope.userSelected.period || {};

        const isPeriodMultiSelect = Array.isArray($scope.userSelected.period);

        if (!$scope.billableYears.length) {
          $scope.userSelected.period = isPeriodMultiSelect
            ? []
            : {
              year: null,
              month: null,
            };
          return;
        }

        let selectedPeriods = isPeriodMultiSelect ? $scope.userSelected.period : [$scope.userSelected.period];
        // Make sure selected periods are aligned with the loaded billable periods.
        selectedPeriods = selectedPeriods
          .filter((period) => period?.year && period?.month)
          .filter((period) => $scope.billableYears.includes(period.year))
          .filter((period) => $scope.billableMonthsByYear[period.year].includes(period.month));

        // Select the most appropriate period if none are selected.
        if (!selectedPeriods.length) {
          const defaultPeriodMoment = moment().date() <= OpencareConstants.automatedBilling.dayStart
            ? moment().subtract(1, 'month')
              .startOf('month')
            : moment().startOf('month');
          const newSelectedPeriod = {};

          if ($scope.billableMonthsByYear[defaultPeriodMoment.year()]?.includes(defaultPeriodMoment.month() + 1)) {
            newSelectedPeriod.year = defaultPeriodMoment.year();
            newSelectedPeriod.month = defaultPeriodMoment.month() + 1;
          } else {
            newSelectedPeriod.year = _.max($scope.billableYears);
            newSelectedPeriod.month = _.max($scope.billableMonthsByYear[newSelectedPeriod.year]);
          }

          $scope.userSelected.period = isPeriodMultiSelect ? [newSelectedPeriod] : newSelectedPeriod;
        } else {
          $scope.userSelected.period = isPeriodMultiSelect ? selectedPeriods : selectedPeriods[0];
        }
      });
    },
  };
});
